import * as React from "react";
const SvgUndoLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.293 6.707a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0l.083.094a1 1 0 0 1-.083 1.32L10.414 5H12a8 8 0 1 1-8 8 1 1 0 1 1 2 0 6 6 0 1 0 6-6h-1.586l1.293 1.293a1 1 0 0 1-1.414 1.414z" }));
export default SvgUndoLine;
